module.exports = __webpack_public_path__ + "static/fonts/Roboto-Light.2defbf2.ttf";